var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgParking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m227 512c-24.8125 0-45-20.1875-45-45v-30c0-8.289062 6.710938-15 15-15h60c8.289062 0 15 6.710938 15 15v30c0 24.8125-20.1875 45-45 45zm0 0",
    fill: "#3e5959"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m437 512c-24.8125 0-45-20.1875-45-45v-30c0-8.289062 6.710938-15 15-15h60c8.289062 0 15 6.710938 15 15v30c0 24.8125-20.1875 45-45 45zm0 0",
    fill: "#293939"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m467 317h-270l23.101562-69.601562c4.199219-12.300782 15.597657-20.398438 28.5-20.398438h166.800782c12.898437 0 24.300781 8.097656 28.5 20.398438zm0 0",
    fill: "#a8ebfa"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m481.097656 312.199219-23.097656-69.300781c-6-18.597657-23.101562-30.898438-42.597656-30.898438h-166.804688c-19.496094 0-36.597656 12.300781-42.597656 30.898438l-23.097656 69.300781c-1.804688 4.5-.902344 9.601562 1.796875 13.5 3 3.898437 7.5 6.300781 12.300781 6.300781h270c4.800781 0 9.300781-2.402344 12.300781-6.300781 2.699219-3.898438 3.601563-9 1.796875-13.5zm-263.398437-10.199219 16.800781-49.800781c1.800781-6 7.800781-10.199219 14.097656-10.199219h166.804688c6.296875 0 12.296875 4.199219 14.097656 10.199219l16.800781 49.800781zm0 0",
    fill: "#cc2e43"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m467 317h-135v-90h83.402344c12.898437 0 24.296875 8.097656 28.496094 20.398438zm0 0",
    fill: "#76e2f8"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m479.300781 325.699219c-3 3.898437-7.5 6.300781-12.300781 6.300781h-135v-30h114.300781l-16.800781-49.800781c-1.800781-6-7.800781-10.199219-14.097656-10.199219h-83.402344v-30h83.402344c19.496094 0 36.597656 12.300781 42.597656 30.898438l23.097656 69.300781c1.804688 4.5.902344 9.601562-1.796875 13.5zm0 0",
    fill: "#ae2538"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m257 332c-3.839844 0-7.675781-1.464844-10.605469-4.394531-5.859375-5.859375-5.859375-15.351563 0-21.210938l30-30c5.859375-5.859375 15.351563-5.859375 21.210938 0s5.859375 15.351563 0 21.210938l-30 30c-2.929688 2.929687-6.765625 4.394531-10.605469 4.394531zm0 0",
    fill: "#4a696f"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m377 332c-3.839844 0-7.675781-1.464844-10.605469-4.394531-5.859375-5.859375-5.859375-15.351563 0-21.210938l30-30c5.859375-5.859375 15.351563-5.859375 21.210938 0s5.859375 15.351563 0 21.210938l-30 30c-2.929688 2.929687-6.765625 4.394531-10.605469 4.394531zm0 0",
    fill: "#3e5959"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m467 302h-270c-24.902344 0-45 20.097656-45 45v90c0 8.398438 6.597656 15 15 15h330c8.402344 0 15-6.601562 15-15v-90c0-24.902344-20.097656-45-45-45zm0 0",
    fill: "#e63950"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m512 347v90c0 8.398438-6.597656 15-15 15h-165v-150h135c24.902344 0 45 20.097656 45 45zm0 0",
    fill: "#cc2e43"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m90 225v212c0 8.398438-6.597656 15-15 15s-15-6.601562-15-15v-212c0-8.402344 6.597656-15 15-15s15 6.597656 15 15zm0 0",
    fill: "#c6e2e7"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m120 437v60h-90v-60c0-8.402344 6.597656-15 15-15h60c8.402344 0 15 6.597656 15 15zm0 0",
    fill: "#4a696f"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m75 452v-242c8.402344 0 15 6.597656 15 15v212c0 8.398438-6.597656 15-15 15zm0 0",
    fill: "#8ebac5"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m120 437v60h-45v-75h30c8.402344 0 15 6.597656 15 15zm0 0",
    fill: "#3e5959"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m135 0h-90c-24.902344 0-45 20.097656-45 45v150c0 24.898438 20.097656 45 45 45h90c41.398438 0 75-33.601562 75-75v-90c0-41.398438-33.601562-75-75-75zm0 0",
    fill: "#3aaaff"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m210 75v90c0 41.398438-33.601562 75-75 75h-60v-240h60c41.398438 0 75 33.601562 75 75zm0 0",
    fill: "#0095ff"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m105 60h-30c-8.402344 0-15 6.597656-15 15v90c0 8.398438 6.597656 15 15 15s15-6.601562 15-15v-15h15c24.902344 0 45-20.101562 45-45 0-24.902344-20.097656-45-45-45zm0 60h-15v-30h15c8.402344 0 15 6.597656 15 15 0 8.398438-6.597656 15-15 15zm0 0",
    fill: "#deecf1"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m105 60h-30v120c8.402344 0 15-6.601562 15-15v-15h15c24.902344 0 45-20.101562 45-45 0-24.902344-20.097656-45-45-45zm0 60h-15v-30h15c8.402344 0 15 6.597656 15 15 0 8.398438-6.597656 15-15 15zm0 0",
    fill: "#c6e2e7"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m257 392h-30c-8.289062 0-15-6.710938-15-15s6.710938-15 15-15h30c8.289062 0 15 6.710938 15 15s-6.710938 15-15 15zm0 0",
    fill: "#deecf1"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m437 392h-30c-8.289062 0-15-6.710938-15-15s6.710938-15 15-15h30c8.289062 0 15 6.710938 15 15s-6.710938 15-15 15zm0 0",
    fill: "#c6e2e7"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m150 497c0 8.398438-6.597656 15-15 15h-120c-8.402344 0-15-6.601562-15-15 0-8.402344 6.597656-15 15-15h120c8.402344 0 15 6.597656 15 15zm0 0",
    fill: "#384949"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m150 497c0 8.398438-6.597656 15-15 15h-60v-30h60c8.402344 0 15 6.597656 15 15zm0 0",
    fill: "#293939"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParking);
export default __webpack_public_path__ + "static/media/parking.e340d3623d2760891f50b8507439d6cd.svg";
export { ForwardRef as ReactComponent };